import React from "react";
import { Dimmer, Loader, Segment } from "semantic-ui-react";
import logo from "../../assets/icons/logo-transparent.svg";

const INITIAL_LOADING = (
  <Segment basic>
    <img src={logo} alt="hello radius logo" />
  </Segment>
);

export default function LoadingComponent({
  inverted = true,
  initialLoading = false,
  content = "Loading...",
  size = "medium",
}) {
  return (
    <Dimmer inverted={inverted} active={true}>
      {!initialLoading && <Loader content={content} size={size} />}
      {initialLoading && <Loader content={INITIAL_LOADING} size={size} />}
    </Dimmer>
  );
}
